import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RiverViewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RiverViewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.3764 11.3241H19.0166C19.3377 11.3241 19.5981 11.0638 19.5981 10.7427C19.5981 10.4215 19.3377 10.1612 19.0166 10.1612H15.3764C15.0553 10.1612 14.7949 10.4215 14.7949 10.7427C14.7949 11.0638 15.0553 11.3241 15.3764 11.3241Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.23636 14.3247C8.23636 14.0036 7.97602 13.7432 7.65489 13.7432H4.98381C4.66268 13.7432 4.40234 14.0036 4.40234 14.3247C4.40234 14.6458 4.66268 14.9062 4.98381 14.9062H7.65489C7.97602 14.9062 8.23636 14.6458 8.23636 14.3247Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.98626 14.9062H13.2388C13.5599 14.9062 13.8203 14.6458 13.8203 14.3247C13.8203 14.0036 13.5599 13.7432 13.2388 13.7432H9.98626C9.66513 13.7432 9.40479 14.0036 9.40479 14.3247C9.40479 14.6458 9.66513 14.9062 9.98626 14.9062Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.5235 16.6499C10.5235 16.3288 10.2632 16.0684 9.94203 16.0684H7.46477C7.14364 16.0684 6.8833 16.3288 6.8833 16.6499C6.8833 16.971 7.14364 17.2314 7.46477 17.2314H9.94203C10.2632 17.2314 10.5235 16.971 10.5235 16.6499Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.3422 2.07623H20.2425C19.4297 2.07623 18.6731 2.32053 18.0417 2.73922C17.6557 2.59823 17.2499 2.52667 16.8312 2.52667C15.0759 2.52667 13.6151 3.80998 13.3368 5.48752H10.663C10.3848 3.80998 8.92391 2.52667 7.16868 2.52667C6.7499 2.52667 6.34419 2.59827 5.95814 2.73922C5.32674 2.32052 4.57013 2.07623 3.75739 2.07623H2.65764C2.33651 2.07623 2.07617 2.33657 2.07617 2.6577V21.3423C2.07617 21.6634 2.33651 21.9238 2.65764 21.9238H21.3422C21.6634 21.9238 21.9237 21.6634 21.9237 21.3423V2.65771C21.9237 2.33658 21.6633 2.07623 21.3422 2.07623ZM20.7607 6.65047V7.83473H16.3567C14.5865 7.83473 12.9222 8.52408 11.6705 9.77583L10.2485 11.1978C10.0947 11.3514 9.89053 11.436 9.6736 11.436H3.2391V6.65047H20.7607ZM3.2391 17.2316H5.13489C5.45602 17.2316 5.71636 16.9712 5.71636 16.6501C5.71636 16.329 5.45602 16.0686 5.13489 16.0686H3.2391V12.5989H9.67365C10.2009 12.5989 10.6969 12.3936 11.0706 12.0204L12.4929 10.5981C13.525 9.56605 14.8971 8.99764 16.3567 8.99764H20.7607V12.487H18.865C18.5438 12.487 18.2835 12.7473 18.2835 13.0684C18.2835 13.3896 18.5438 13.6499 18.865 13.6499H20.7607V14.8124H16.3567C15.8294 14.8124 15.3335 15.0177 14.9597 15.3909L13.5374 16.8132C12.5053 17.8452 11.1332 18.4136 9.67364 18.4136H3.2391V17.2316ZM20.7607 3.23918V5.48753H17.4727C17.7416 4.20512 18.8813 3.23918 20.2425 3.23918H20.7607ZM16.8312 3.68963C16.8985 3.68963 16.9652 3.69327 17.0314 3.69874C16.6498 4.21439 16.3893 4.82474 16.2922 5.48754H14.524C14.7841 4.45574 15.7197 3.68963 16.8312 3.68963ZM9.47591 5.48754H7.7077C7.61056 4.82474 7.35006 4.21439 6.96842 3.69874C8.1383 3.59148 9.20688 4.39112 9.47591 5.48754ZM3.2391 3.23918H3.75738C5.11853 3.23918 6.25829 4.20512 6.52716 5.48753H3.2391V3.23918ZM3.2391 20.7608V19.5766H9.67365C11.4438 19.5766 13.1081 18.8872 14.3598 17.6355L15.7818 16.2135C15.9356 16.0599 16.1398 15.9753 16.3567 15.9753H20.7608V20.7608H3.2391Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RiverViewIcon;
